import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';

import SingleSelect from '../../../generic/SingleSelect';
import { productLabel } from '../../../products/constants';
import { productShape } from '../../../prop-types';

class ProductSelection extends React.PureComponent {
  render() {
    const { products, selectedProductId, onChange, readOnly } = this.props;

    const filteredProducts = products.filter(p => !p.deprecated);
    const options = filteredProducts.map(p => ({
      label: productLabel(p),
      value: p.id,
    }));

    return (
      <SingleSelect
        options={options}
        value={selectedProductId}
        onChange={onChange}
        name="productId"
        readOnly={readOnly}
      />
    );
  }
}

ProductSelection.propTypes = {
  products: arrayOf(productShape.isRequired).isRequired,
  selectedProductId: number,
  onChange: func.isRequired,
  readOnly: bool,
};

ProductSelection.defaultProps = {
  selectedProductId: undefined,
  readOnly: false,
};

export default ProductSelection;
